import { render, staticRenderFns } from "./PMS.vue?vue&type=template&id=2e56e9f9&"
import script from "./PMS.vue?vue&type=script&lang=js&"
export * from "./PMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports